module.exports = __webpack_public_path__ + "static/media/habasta_thumb_even.47ad4891.webp";